import { AfterViewInit, Component, Inject, InjectionToken, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import 'zone.js';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MessagingService } from './services/messaging.service';


@Component({
  selector: 'xplora-luxe-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, TranslateModule, HttpClientModule, NgxUiLoaderModule],
  providers: [TranslateService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'xplora-luxe';

  constructor(public translate: TranslateService, private router: Router,  private _messagingService: MessagingService,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<object>

  ) {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {

        document.body.scrollTop = 0;
        setTimeout(() => {

          window.scrollTo(0, 0);
        }, 0);
      }
    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this._messagingService.requestPermission();
        this._messagingService.listenForFrontMessages();
        this.translate.get('notificationAlert').subscribe(() => {
          // if (Notification.permission === 'denied' && this.translate.store.translations) {
          //   alert(this.translate.instant('notificationAlert'));
          // }
        });
      }
    }, 5000);

  }
}
